import MOptionGroup from './MOptionGroup.vue';

MOptionGroup.install = (app) => {
  app.component('MOptionGroup', MOptionGroup);
};

export { MOptionGroup };
